import { render, staticRenderFns } from "./DialogQA.vue?vue&type=template&id=c4eaf67e&"
import script from "./DialogQA.vue?vue&type=script&lang=js&"
export * from "./DialogQA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports